import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { SidebarNavItemProps } from '../types';
import styles from '../Sidebar.module.css';

export const SidebarNavItem: React.FC<SidebarNavItemProps> = ({
  item,
  onClick,
  indented = false,
}) => {
  const { t } = useTranslation();
  const Icon = item.icon;

  return (
    <NavLink
      to={item.href}
      onClick={onClick}
      className={({ isActive }) =>
        `${styles.navItem} ${indented ? styles.navItemIndented : ''} ${isActive ? styles.navItemActive : ''}`
      }
    >
      <Icon size={12} className={styles.navItemIcon} />
      <span className={styles.navItemLabel}>
        {item.labelKey ? t(item.labelKey) : item.label}
        {item.beta && <span className={styles.navItemBeta}>{t('sidebar.beta', 'Beta')}</span>}
      </span>
    </NavLink>
  );
};
